import "../styles/default.scss";

import autoBind from "auto-bind";
import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import Headroom from "react-headroom";
import { Container, Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import { UrlProvider } from "../../../../../api/UrlProvider";
import { getLoginWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";
import config from "../../../../../config";
import logo from "../../../../../logo";
import PaymentAlert from "../../../common/PaymentAlert";
import SearchBar from "../../../common/SearchBar";
import SquaberLink from "../../../common/SquaberLink";
import NotificationIndicator from "../../../navigation/NotificationIndicator";
import MainMenu from "../../MainMenu/modules/default";
import PLAN_NAMES from "../../../landingPage/pages/Plans/utils/planNames";

class Header extends Component {
  constructor(props) {
    super(props);
    this.headerRef = createRef();
    this.mainMenuRef = createRef();

    autoBind.react(this);
  }

  static propTypes = {
    userData: PropTypes.shape({
      firstName: PropTypes.string,
      email: PropTypes.string
    }),
    logout: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    userData: {}
  };

  state = {
    userDropdownOpen: false,
    searchBarOpen: false
  };

  activeSignalsElementId = "#active-signals-list";

  toggleUser() {
    this.setState(prevState => ({
      userDropdownOpen: !prevState.userDropdownOpen
    }));
  }

  setSearchBarOpen(newValue, callback) {
    this.setState({ searchBarOpen: newValue }, callback);
  }

  setNotificationsOpen({ open, tabName, callback }) {
    this.props.setNotificationsOpen({ open, tabName });

    if (callback) {
      callback();
    }
  }

  closeUserMenuDropdown() {
    const { isMobile } = this.props;

    if (!isMobile) {
      this.setState({
        userDropdownOpen: false
      });
    }
  }

  onLogout = () => {
    const { logout } = this.props;
    logout();
  };

  getName = () => {
    const { first_name, last_name, username } = this.props.userData;
    return first_name ? `${first_name} ${last_name}` : username;
  };

  getTextLogo() {
    throw new Error("You have to implement this method in child class");
  }

  getRegisterUrl() {
    throw new Error("You have to implement this method in child class");
  }

  getRegisterTarget() {
    throw new Error("You have to implement this method in child class");
  }

  componentDidUpdate() {
    const headerHeight = this.headerRef.current?.clientHeight;
    const { setNavbarHeight, navbarHeight } = this.props;

    if (headerHeight !== navbarHeight) {
      setNavbarHeight(headerHeight);
    }
  }

  render() {
    const {
      userData,
      paymentDetails,
      translate,
      locale,
      location,
      appStatus: { error: appError },
      bottomNavigationValue,
      isMobile
    } = this.props;

    if (
      isMobile &&
      bottomNavigationValue &&
      bottomNavigationValue === "watched"
    ) {
      return null;
    }

    const loggedIn = !!(userData && userData.username);

    const currentPlan =
      paymentDetails?.plan_name ?? userData?.current_plan?.name;

    const shouldShowSearchBar =
      !appError &&
      location.pathname !== UrlProvider.getUrl("fe.search", { locale });

    return (
      <Headroom
        disableInlineStyles
        upTolerance={80}
      >
        <header ref={this.headerRef}>
          <div className="navbar navbar-expand-lg">
            <div className="first-row navbar-dark">
              <Container>
                <SquaberLink to="/" className="navbar-brand">
                  <div className="logo-holder ">
                    <img
                      src={
                        currentPlan === PLAN_NAMES.PRO
                          ? logo.iconWithTextWebPro
                          : currentPlan === PLAN_NAMES.PREMIUM
                          ? logo.iconWithTextWebPremium
                          : currentPlan === PLAN_NAMES.INSIDER
                          ? logo.iconWithTextWebInsider
                          : currentPlan === PLAN_NAMES.START
                          ? logo.iconWithTextWebStart
                          : logo.iconWithTextWeb
                      }
                      className="img-fluid"
                      alt={config.title}
                    />
                  </div>
                </SquaberLink>

                <SearchBar
                  shouldShowSearchBar={shouldShowSearchBar}
                  searchBarOpen={this.state.searchBarOpen}
                  setSearchBarOpen={this.setSearchBarOpen.bind(this)}
                />

                {loggedIn ? (
                  <div className="auth">
                    <NotificationIndicator
                      setNotificationsOpen={this.setNotificationsOpen}
                      notificationsOpen={this.props.notificationsOpen}
                    />
                    <div className="user-menu">
                      <Dropdown
                        isOpen={this.state.userDropdownOpen}
                        toggle={this.toggleUser}
                      >
                        <DropdownToggle caret nav>
                          {this.getName()}
                        </DropdownToggle>
                        <DropdownMenu right>
                          <SquaberLink
                            onClick={() => {
                              this.closeUserMenuDropdown();
                            }}
                            to={UrlProvider.getUrl("fe.settingsPageCategory", {
                              locale,
                              settingsCategory: "personal"
                            })}
                          >
                            {translate("Account")}
                          </SquaberLink>
                          <SquaberLink
                            onClick={() => {
                              this.closeUserMenuDropdown();
                            }}
                            to={UrlProvider.getUrl("fe.settingsPageCategory", {
                              locale,
                              settingsCategory: "notifications"
                            })}
                          >
                            {translate("Settings")}
                          </SquaberLink>
                          <SquaberLink
                            onClick={event => {
                              this.closeUserMenuDropdown();
                              event.preventDefault();
                              this.onLogout();
                            }}
                            to={""}
                          >
                            {translate("Logout")}
                          </SquaberLink>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                ) : (
                  <ul className="navbar-nav auth">
                    <li className="auth-item">
                      <SquaberLink to={getLoginWithRedirectUrl({ locale })}>
                        {translate("Log in")}
                      </SquaberLink>
                    </li>
                    <li className="auth-item registration">
                      <SquaberLink
                        to={this.getRegisterUrl()}
                        target={this.getRegisterTarget()}
                      >
                        {translate("Register")}
                      </SquaberLink>
                    </li>
                  </ul>
                )}
              </Container>
            </div>
            <MainMenu ref={this.mainMenuRef} />
            <PaymentAlert />
          </div>
        </header>
      </Headroom>
    );
  }
}

export default Header;
